'use client';
import { useSuspenseQuery } from '@tanstack/react-query';

import { generateJsonLdFromData } from '@/lib/helper';

import { BreadcrumbList } from '@/components/@base/breadcrumb/type';
import { ARCHIVE_PAGE_TYPE } from '@/components/app/archive/helpers';
import { getArchiveInfoQueryOptions } from '@/components/app/archive/services/hooks';
import { BreadcrumbLdJson } from '@/components/shared/@meta/schema';

import localization, { pageLevelLocalization } from '@/constant/localization';

type Props = {
  slug: string;
  type: ARCHIVE_PAGE_TYPE;
};
const { archive: archiveLocalization } = pageLevelLocalization;
export default function ArchiveLdJson({ slug, type }: Props) {
  const { data } = useSuspenseQuery(getArchiveInfoQueryOptions(slug, type));

  const currentBreadcrumb: BreadcrumbList = {
    label: archiveLocalization.searchResult,
    active: true,
  };

  const breadcrumbList: BreadcrumbList[] = [
    { label: localization.home, url: '/', active: false },
    currentBreadcrumb,
  ];

  return (
    <>
      <BreadcrumbLdJson breadcrumbs={breadcrumbList} />
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(generateJsonLdFromData(data?.faq, data?.title)),
        }}
      />
    </>
  );
}
